export const partition = <T>(
	items: ReadonlyArray<T> | undefined | null,
	condition: (x: T, index?: number) => boolean
): [Array<T>, Array<T>] => {
	const [matched, unmatched]: Array<Array<T>> = [[], []];
	const actualItems = items || ([] as Array<T>);
	for (let index = 0; index < actualItems.length; index++) {
		const element = actualItems[index];
		(condition(element, index) ? matched : unmatched).push(element);
	}
	return [matched, unmatched];
};

/**
 * Partitions items into arrays corresponding to the provided conditions.
 *
 * @param {ReadonlyArray<T>|undefined|null} items - An array of items to be partitioned
 * @param {Array<(x: T) => boolean>} conditions - An array of conditions the items are being checked against
 *
 * @returns {Array<Array<T>>} Array of length conditions + 1. The Array at position conditions.length is holding items that failed all provided conditions
 */
export const multiPartition = <T>(items: ReadonlyArray<T> | undefined | null, conditions: Array<(x: T) => boolean>): Array<Array<T>> =>
	(items || ([] as Array<T>)).reduce(
		(resultArrays, item) => {
			const matchedConditionIndex = conditions.findIndex((condition) => condition(item));
			matchedConditionIndex === -1 ? resultArrays[conditions.length].push(item) : resultArrays[matchedConditionIndex].push(item);
			return resultArrays;
		},
		[...conditions.map((_) => []), []] as Array<Array<T>>
	);
